import { Simulator } from "@/components/marketing/Simulator";
import type { OpenLeadFn } from "./types";

type SimulatorMobileProps = {
  openLead: OpenLeadFn;
};

export function SimulatorMobile({ openLead }: SimulatorMobileProps) {
  return (
    <section
      id="simulador"
      className="w-full py-10 bg-[var(--sr-cream)] lg:hidden"
      aria-label="Simulador mobile"
    >
      <div className="w-full max-w-md mx-auto px-4">
        <Simulator onLead={(v, val) => openLead("simulator_mobile", v, val)} />
      </div>
    </section>
  );
}
